import React, { useState, useEffect } from 'react';
import './FilterToggle.css';

const mobileBrakePoint = 620;

function FilterToggle({ children, results, onViewAllClick, isWhite }) {
	const [viewportSize, setViewportSize] = useState({
		width: window.innerWidth,
	});

	const whiteStyles = {
		color: 'white',
		borderBottom: '1px solid white',
		':hover': {
			color: '#9ca49e !important',
		},
	};

	useEffect(() => {
		function handleResize() {
			setViewportSize({
				width: window.innerWidth,
			});
		}

		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	const [isOn, setIsOn] = useState(false);

	const handleToggle = () => {
		setIsOn(!isOn);
	};

	const handleViewAllClick = (e) => {
		e.stopPropagation();
		onViewAllClick();
	};

	return (
		<div className='filter-toggle-container'>
			<button
				className={
					viewportSize.width < mobileBrakePoint
						? isOn
							? 'filter-toggle-button filter-toggle-body-open'
							: 'filter-toggle-button'
						: 'not-active-button'
				}
				style={isWhite && whiteStyles}
				onClick={handleToggle}
			>
				<div className='filter-button-column'>
					<div
						className={
							isWhite
								? 'filter-button-text filter-text-white'
								: 'filter-button-text'
						}
						onClick={handleViewAllClick}
					>
						VIEW ALL{' '}
					</div>

					<div
						className={
							isWhite
								? 'filter-button-results filter-text-white'
								: 'filter-button-results'
						}
					>
						{`${results} Results`}
						{isOn ? (
							<div className='filter-toggle-arrow  filter-rotated-arrow-up'>
								&#10132;
							</div>
						) : (
							<div className='filter-toggle-arrow  filter-rotated-arrow-down'>
								&#10132;
							</div>
						)}
					</div>
				</div>
			</button>

			<div
				className={
					viewportSize.width < mobileBrakePoint
						? isOn
							? 'filter-toggle-body filter-toggle-body-on'
							: 'filter-toggle-body filter-toggle-body-off'
						: 'filter-toggle-body filter-toggle-body-on'
				}
				style={
					isWhite && { borderBottomColor: 'transparent', paddingBottom: '45px' }
				}
			>
				{children}

				{isWhite && <div className='white-border-divider' />}
			</div>
		</div>
	);
}

export default FilterToggle;
